import { render, staticRenderFns } from "./CartTokenComponent.vue?vue&type=template&id=9af289b2&"
import script from "./CartTokenComponent.vue?vue&type=script&lang=js&"
export * from "./CartTokenComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports